import { Tag } from "@dmm-com/rocket-web-ui-library";
import { memo } from "react";
import type { G_GetVideoQuery } from "~/lib/graphql";
import { getTagText } from "~/util/get-tag-text";

type ItemPackageTagProps = {
  isNewArrival: boolean;
  isExclusive: boolean;
  customTag?: G_GetVideoQuery["video"]["customTag"];
};

/**
 * video homeでitemPackageの左上に表示するTag component
 * 仕様memo: (okita) 「独占|New」＞「New」＝「独占」
 * */
export const LeftTag = memo(({ isNewArrival, isExclusive, customTag }: ItemPackageTagProps) => {
  const tagText = getTagText({ isNewArrival, isExclusive, customTag });
  if (tagText === null) return null;

  return <Tag tagText={tagText} bgColor="RED900" />;
});

LeftTag.displayName = "LeftTag";
